import React, { useCallback, useEffect, useState } from 'react'
import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Flex,
    Heading,
    Text,
    useDisclosure,
    useToast,
    Button,
} from '@chakra-ui/react';
import { MultiSelect } from "react-multi-select-component";
import { AiFillDelete } from "react-icons/ai";
import { useSelector } from 'react-redux';
import axios from 'axios';
import TeamsDetailsModal from './TeamsDetailsModal';
import { useParams } from 'react-router-dom';

const UpdateMember = () => {
    const [data, setData] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selected, setSelected] = useState([]);
    const { isOpen, onClose } = useDisclosure();
    const [teamDetails, setTeamDetails] = useState(null);
    const user = useSelector((state) => state.user.userData);
    const toast = useToast();
    const orgId = useSelector((state) => state.user.orgId);
    const { teamId } = useParams();
    const allTeams = useSelector((state) => state.teams.allTeams);
    const team = allTeams.find((team) => team.teamId === +teamId);

    const getAllTeamUsers = useCallback(() => {
        const params = {
            userId: user.userId,
            teamId: team.teamId,
        }
        axios.get(`http://18.132.190.48:8080/api/v1/getAllUser/team?`, { params })
            .then((r) => {
                setData(r.data)
            })
            .catch((err) => console.log(err))
    }, [user.userId, team.teamId]);

    const getAllUsers = useCallback(() => {
        const params = {
            userId: user.userId,
            orgId
        }
        axios.get(`http://18.132.190.48:8080/api/v1/getAllUsers`, { params })
            .then((r) => {
                setAllUsers(r.data);
            })
            .catch((err) => console.log(err))
    }, [user.userId, orgId]);

    const updateTeam = () => {
        axios.put(`http://18.132.190.48:8080/api/v1/team/${team.teamId}/assignUsers?userId=${user.userId}`, {
            empIds: selected.map((e) => e.value)
        })
            .then((r) => {
                console.log("response in put", r)
                getAllTeamUsers();
                setSelected([]);
                toast({
                    title: "Users added to team",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                })
            })
            .catch((err) => console.log(err))
    }

    const removeUser = (empId) => {
        axios.delete(`http://18.132.190.48:8080/api/v1/delete/team/${team.teamId}/removeUsers?userId=${user.userId}&empId=${empId}`)
            .then(() => {
                setData(prevData => prevData.filter(user => user.empId !== empId));
                toast({
                    title: "User Removed from team",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                })
            })
            .catch((err) => console.log(err))
    }

    useEffect(() => {
        getAllTeamUsers();
        getAllUsers()
    }, [getAllTeamUsers, getAllUsers]);


    return (
        <>
            <Box m="auto" my={"40px"} w="50%">
                <Flex justify="space-evenly">
                    <Text fontSize="20px" fontWeight="bold" mt={1}  > TeamName:<Text ml={2} color="purple" fontSize="24px" mt={2} textDecoration="underline">{team.teamName}</Text></Text>
                </Flex>
                <Flex mt={10}>
                    <Text fontWeight="bold" mt={1} mr={5}>Add Users :</Text>
                    <Box w="400px" border="1px solid" >
                        <MultiSelect
                            options={allUsers.map((e) => ({ label: e.email, value: e.empId }))}
                            value={selected}
                            onChange={setSelected}
                            labelledBy="Select"
                        />
                    </Box>
                </Flex>
                <Button ml="250px" bgColor="lightblue" mt={5} onClick={updateTeam}>Add Members</Button>
            </Box>
            <Box>
                <Heading textAlign="center" size="md">Existing Teams</Heading>
                <TableContainer w="40%" m="auto" mt={5} bgColor="white">
                    <Table >
                        <Thead>
                            <Tr>
                                <Th bgColor="lavender" border="1px solid black" color="black" py={4}>Team Users</Th>
                                <Th bgColor="lavender" border="1px solid black" color="black" py={4}>Remove User </Th>
                            </Tr>
                        </Thead>
                        {
                            data?.map((e) => (
                                <Tbody key={e.empId}>
                                    <Tr>
                                        <Td py={2} border="1px solid black" color="black" fontWeight="semibold">{e.fullname}</Td>
                                        <Td py={2} border="1px solid black"><AiFillDelete onClick={() => removeUser(e.empId)} size="25px" color="red" /></Td>
                                    </Tr>
                                </Tbody>
                            ))
                        }
                    </Table>
                </TableContainer>
                {teamDetails && isOpen && <TeamsDetailsModal isOpen={isOpen} team={teamDetails} onClose={onClose} />}
            </Box>
        </>
    )
}

export default UpdateMember;
